import { IN_FLIGHT_FIELDS_KEY } from '@/constants';

export class InFlightValue {
  value = null;

  constructor(value) {
    this.value = value;
  }

  toString() {
    return `${this.value} (Updating)`;
  }

  /**
   * Wraps values that are marked "in-flight" to allow EditableDropdownCell to
   * indicate that the backend value update is in progress for the corresponding cell
   * @param {object[]} dataRows An array of objects that represent data rows. If a row
   * specifies that any of its fields are "in-flight" by including the field's name
   * in the "IN_FLIGHT_FIELDS" collection, its value will be wrapped with the
   * `InFlightValue` class
   * @returns {object[]} The rows that were passed in with "in-flight" values wrapped inside
   * `InFlightValue`
   */
  static wrapInFlightRows(dataRows) {
    return dataRows.map((row) => {
      const inFlightFields = row[IN_FLIGHT_FIELDS_KEY];
      if (!inFlightFields) {
        return row;
      }

      const inFlightFieldValuePairs = (inFlightFields || []).map((field) => ({
        [field]: new InFlightValue(row[field]),
      }));

      return Object.assign({}, row, ...inFlightFieldValuePairs);
    });
  }
}
